import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClientService } from 'app/core/services/http-client.service';

import { Machine, ResponseMetadata } from 'app/model';
import { EndpointsConstants } from 'app/shared/constants/endpoints.constants';

@Injectable()
export class MachineService {

  constructor(private httpService: HttpClientService) {
  }

  getAllMachines(params?: {}): Observable<{ machines: Machine[], metadata: ResponseMetadata }> {
    return this.httpService
      .get<{ machines: Machine[], metadata: ResponseMetadata }>(EndpointsConstants.machine.all, params)
      .pipe(map(response => {
        return {
          machines: response['data'].machines.map(machine => new Machine(machine)),
          metadata: response['data'].metadata
        };
      }));
  }

  getMachine(id: string): Observable<Machine> {
    const endpointUrl = EndpointsConstants.machine.single.replace('{id}', id);
    return this.httpService.get<Machine>(endpointUrl).pipe(map(response => new Machine(response['data'])));
  }

  saveMachine(machine: Machine): Observable<Machine> {
    return this.httpService.post(EndpointsConstants.machine.all, machine)
      .pipe(map(response => new Machine(response['data'])));
  }

  updateMachine(id: string, editedMachine: Machine): Observable<Machine> {
    const endpointUrl = EndpointsConstants.machine.single.replace('{id}', id);
    return this.httpService.put(endpointUrl, editedMachine).pipe(map(response => new Machine(response['data'])));
  }

  deleteMachine(id: string): Observable<{ message: string }> {
    const endpointUrl = EndpointsConstants.machine.single.replace('{id}', id);
    return this.httpService.delete<{ message: string }>(endpointUrl);
  }
}
